import { render, staticRenderFns } from "./ProductionPreps.vue?vue&type=template&id=1e58d12f&"
import script from "./ProductionPreps.vue?vue&type=script&lang=ts&"
export * from "./ProductionPreps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports